import {
  collection,
  getDocs,
  onSnapshot,
  query,
  type QueryDocumentSnapshot,
} from 'firebase/firestore';
import { db } from '@/lib/firebase';
import type { Venue } from '@/types';

function docToVenue(doc: QueryDocumentSnapshot): Venue {
  const data = doc.data() as Partial<Venue>;
  return {
    id: doc.id,
    name: data.name ?? '',
    description: data.description,
    city: data.city ?? '',
    country: data.country ?? '',
    latitude: data.latitude,
    longitude: data.longitude,
    category: data.category ?? 'unknown',
    createdAt: data.createdAt,
    updatedAt: data.updatedAt,
  };
}

export const venueService = {
  async getVenues(): Promise<Venue[]> {
    const snap = await getDocs(query(collection(db, 'venues')));
    return snap.docs.map(docToVenue);
  },

  subscribeToVenues(callback: (venues: Venue[]) => void) {
    return onSnapshot(collection(db, 'venues'), snap => {
      callback(snap.docs.map(docToVenue));
    });
  },
};
